class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.setHeaderCartIconAccessibility();
    this.addEventListener('keyup', function (event) {
      if (event.code.toUpperCase() === 'ESCAPE') {
        this.close.bind(this)(event);
      }
    }.bind(this), false);

    console.log('[CartDrawer] Initialized');
  }

  setHeaderCartIconAccessibility() {
    const _this = this;
    const cartLink = document.querySelector('#cart-icon-bubble') || document.querySelector('#cart-icon-bubble-mobile');
    const cartAction = document.querySelectorAll('.icon--cart-action');

    if (cartLink) {
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
    }

    if (cartAction.length != 0) {
      cartAction.forEach(e => {
        e.addEventListener('click', (event) => {
          event.preventDefault();
          console.log('[CartDrawer] Cart icon clicked');
          _this.open(e);
        });
      });
    }
  }

  open(triggeredBy) {
    handleFloCartBtn();
    // console.log('[CartDrawer] Opening drawer');
    // closePopup.hide();
    // if (triggeredBy) this.setActiveElement(triggeredBy);

    // // Remove is-empty class immediately
    // this.classList.remove('is-empty');
    // if (this.querySelector('.drawer__inner')) {
    //   this.querySelector('.drawer__inner').classList.remove('is-empty');
    // }

    // setTimeout(() => {
    //   trapFocus(document.querySelector("cart-drawer"));
    // }, 500);

    // setTimeout(() => {
    //   this.classList.add('active');
    //   console.log('[CartDrawer] Drawer opened');
    // });

    // root.classList.add('open-canvas');
    // rootAction.addNoneHeight();

    // const cartRecommend = document.querySelector(".cart-upsell-js.cart-type-select");
    // if (cartRecommend) {
    //   const productRecommend = cartRecommend.querySelector('.slide-container');
    //   if (productRecommend && productRecommend.childElementCount === 0) {
    //     const drawerInner = document.querySelector('.drawer__inner');
    //     if (drawerInner) {
    //       drawerInner.classList.add('hidden-cart-upsell');
    //     }
    //   }
    // }

    // this.updateFreeShippingBar();
  }

  close() {
    console.log('[CartDrawer] Closing drawer');
    removeTrapFocus(this.activeElement);
    rootAction.remove();
    this.classList.remove('active');
  }

  renderContents(parsedState) {
    console.log('[CartDrawer] renderContents called', parsedState);

    // Critical: Remove is-empty class FIRST
    this.classList.remove('is-empty');
    const drawerInner = this.querySelector('.drawer__inner');
    if (drawerInner) {
      drawerInner.classList.remove('is-empty');
    }

    this.productId = parsedState.id;

    // Render each section
    this.getSectionsToRender().forEach(((section, index) => {
      try {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);

        if (!sectionElement) {
          console.error(`[CartDrawer] Section element not found:`, section);
          return;
        }

        if (!parsedState.sections || !parsedState.sections[section.id]) {
          console.error(`[CartDrawer] Section data not found for:`, section.id);
          return;
        }

        const newHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );

        if (newHTML) {
          sectionElement.innerHTML = newHTML;
          console.log(`[CartDrawer] Updated section: ${section.id}`);
        }

        // Handle cart recommendations
        const cartDrawer = this.getSectionDOM(parsedState.sections[section.id], section.selector);
        if (cartDrawer) {
          const cartRecommend = cartDrawer.querySelector(".cart-upsell-js.cart-type-select");
          if (cartRecommend) {
            const productRecommend = cartRecommend.querySelector('.slide-container');
            if (productRecommend && productRecommend.childElementCount == 0) {
              const inner = document.querySelector('.drawer__inner');
              if (inner) {
                inner.classList.add('hidden-cart-upsell');
              }
            }
          }
        }

        // Update mobile cart count
        if (index === 1) {
          const mobile_nav_bar_id = document.querySelector("#cart-icon-bubble-mobile");
          if (mobile_nav_bar_id && mobile_nav_bar_id.querySelector(".cart-count") && sectionElement.querySelector(".cart-count")) {
            mobile_nav_bar_id.querySelector(".cart-count").innerHTML = sectionElement.querySelector(".cart-count").innerHTML;
          }
        }
      } catch (error) {
        console.error(`[CartDrawer] Error rendering section ${section.id}:`, error);
      }
    }));

    // Update free shipping bar
    this.updateFreeShippingBar();

    // Re-initialize upsell scroll arrows if function exists
    if (typeof initializeUpsellScroll === 'function') {
      setTimeout(initializeUpsellScroll, 100);
    }

    // Re-initialize offers modal after content update
    if (typeof initializeOffersModal === 'function') {
      setTimeout(initializeOffersModal, 100);
    }

    // Dispatch event for other scripts that need to know cart drawer was updated
    document.dispatchEvent(new CustomEvent('cart:drawer-rendered', { detail: { cart: parsedState } }));

    // Open the drawer IMMEDIATELY
    console.log('[CartDrawer] Opening drawer after render');
    this.open();
  }

  updateFreeShippingBar() {
    const freeShippingWrapper = this.querySelector('.fs-progress-bar-wrapper');
    if (!freeShippingWrapper) {
      console.log('[CartDrawer] No free shipping wrapper found');
      return;
    }

    fetch('/cart.js?_=' + Date.now())
      .then(res => res.json())
      .then(cart => {
        const total = cart.total_price;
        const limit = parseInt(freeShippingWrapper.dataset.feAmount) * 100;
        const unavailableMsg = freeShippingWrapper.dataset.feUnavaiable;
        const availableMsg = freeShippingWrapper.dataset.feAvaiable;
        const progressBar = freeShippingWrapper.querySelector('.progress');
        const messageDiv = freeShippingWrapper.querySelector('.message');

        if (!progressBar || !messageDiv) return;

        let percent = (total / limit) * 100;
        if (percent > 100) percent = 100;

        progressBar.style.width = `${percent}%`;

        if (total >= limit) {
          messageDiv.innerHTML = availableMsg;
          freeShippingWrapper.classList.add('free-shipping');
        } else {
          const remaining = limit - total;
          let msg = unavailableMsg;

          // Try to format the money
          try {
            if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
              const formatted = Shopify.formatMoney(remaining, themeGlobalVariables.settings.money_format);
              msg = msg.replace('{{amount}}', formatted);
            } else {
              msg = msg.replace('{{amount}}', (remaining / 100).toFixed(2));
            }
          } catch (e) {
            msg = msg.replace('{{amount}}', (remaining / 100).toFixed(2));
          }

          messageDiv.innerHTML = msg;
          freeShippingWrapper.classList.remove('free-shipping');
        }
      })
      .catch(e => console.error("[CartDrawer] Error updating free shipping bar:", e));
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    try {
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const element = parsed.querySelector(selector);
      if (!element) {
        console.error(`[CartDrawer] Selector not found: ${selector}`);
        return '';
      }
      return element.innerHTML;
    } catch (error) {
      console.error('[CartDrawer] Error parsing HTML:', error);
      return '';
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    try {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector);
    } catch (error) {
      console.error('[CartDrawer] Error getting section DOM:', error);
      return null;
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartNoteElement extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.toggleCartNote();
  }
  toggleCartNote() {
    const title = this.querySelector(".cart-note-title-js");
    if (!title) return;
    title.addEventListener("click", this.onToggle.bind(this), false);
    this.addEventListener('keypress', function (event) {
      if (event.key === 'Enter') {
        this.onToggle.bind(this)(event);
      }
    }.bind(this), false);
  }
  onToggle(e) {
    const _this = this;
    e.preventDefault();
    if (!_this.querySelector(".cart-note-content")) return;
    slideAnime({
      target: _this.querySelector(".cart-note-content"),
      animeType: "slideToggle",
    });
  }
}
customElements.define('cart-note-element', CartNoteElement);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  // Optimized Update: Always fetch fresh discounts on every cart change (up or down)
  updateQuantity(line, quantity, name) {
    const _this = this;
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity
    });

    // Step 1: Execute Quantity Change
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        
        if (parsedState.errors) {
          const quantityElement = document.getElementById(`Drawer-quantity-${line}`);
          if (quantityElement) {
            quantityElement.value = quantityElement.getAttribute('value');
          }
          _this.updateLiveRegions(line, parsedState.errors);
          throw new Error('quantity_update_failed');
        }

        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.classList.toggle('is-empty', parsedState.item_count === 0);
        }

        // Step 2: Wait for Bundler app to process (optimized to 1 second)
        return new Promise(resolve => setTimeout(resolve, 1000));
      })
      .then(() => {
        // Step 3: Force discount recalculation by clearing bundle cache
        return fetch(`${routes.cart_update_url}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            attributes: { '_discount_refresh': Date.now() }
          })
        });
      })
      .then(() => {
        // Step 4: Fetch ALL fresh data including cart.js for discount codes
        return Promise.all([
          fetch(`${routes.cart_update_url}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              sections: ['cart-drawer', 'cart-icon-bubble', 'main-cart-items'],
              sections_url: window.location.pathname
            })
          }).then(res => res.json()),
          fetch('/cart.js?_=' + Date.now()).then(res => res.json())
        ]);
      })
      .then(([parsedState, cartData]) => {
        console.log('[CartDrawer] Fresh cart data:', cartData);
        console.log('[CartDrawer] Total discount:', cartData.total_discount);
        console.log('[CartDrawer] Cart attributes:', cartData.attributes);
        
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && parsedState.sections) {
          cartDrawer.renderContents(parsedState);
        }
        
        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { 
            source: 'cart-drawer-items', 
            cart: parsedState,
            cartData: cartData 
          });
        }
      })
      .catch((error) => {
        if (error.message !== 'quantity_update_failed') {
          console.error('[CartDrawerItems] Error:', error);
          const errors = document.getElementById('CartDrawer-CartErrors');
          if (errors) errors.textContent = window.cartStrings?.error || 'Something went wrong';
        }
      })
      .finally(() => {
        _this.disableLoading(line);
      });
  }

  // Helper to update cart icon bubbles
  updateCartIconBubble(sections) {
    if (sections['cart-icon-bubble']) {
      const iconBubble = document.getElementById('cart-icon-bubble');
      if (iconBubble) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
        const newBubble = doc.querySelector('.shopify-section');
        if (newBubble) {
          iconBubble.innerHTML = newBubble.innerHTML;
        }
      }
      // Also update mobile cart icon
      const mobileIconBubble = document.getElementById('cart-icon-bubble-mobile');
      if (mobileIconBubble) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
        const cartCount = doc.querySelector('.cart-count');
        const mobileCartCount = mobileIconBubble.querySelector('.cart-count');
        if (cartCount && mobileCartCount) {
          mobileCartCount.innerHTML = cartCount.innerHTML;
        }
      }
    }
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

class MinicartUpsell extends HTMLElement {
  constructor() {
    super();
  }
  init() {
    this.connectedCallback();
  }
  connectedCallback() {
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.slide-container');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.querySelector(".slide-container").innerHTML = recommendations.innerHTML;
        }
      })
      .finally(() => {
        setTimeout(() => {
          if (this.querySelector("slide-section")) {
            this.querySelector("slide-section").initSlide();
          }
        }, 100);
      })
      .catch(e => {
        console.error(e);
      });
  }
}

customElements.define('minicart-recommendations', MinicartUpsell);